import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.empty');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-empty',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.empty/view.scss */
:host {
  background: var(--hn-canvas);
  display: block;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  width: 100%;
}

@supports (height: 100dvh) {
  :host {
    height: 100dvh;
    min-height: 100dvh;
  }
}
.hn-empty-loading {
  -webkit-backdrop-filter: blur(7px);
  align-items: center;
  backdrop-filter: blur(7px);
  background: rgba(18, 21, 18, 0.28);
  display: flex;
  inset: 0;
  justify-content: center;
  position: fixed;
  z-index: 100;
}

.hn-empty-loading__spinner {
  animation: hn-empty-spin 0.75s linear infinite;
  border: 3px solid rgba(255, 255, 255, 0.42);
  border-radius: 50%;
  border-top-color: var(--hn-accent);
  height: 40px;
  width: 40px;
}

@keyframes hn-empty-spin {
  to {
    transform: rotate(360deg);
  }
}`],
})
export class LayoutEmptyComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }
}

export default LayoutEmptyComponent;